import { createPortal } from 'react-dom';
import { Loader2 } from 'lucide-react';

export function GeneratingOverlay({ show }: { show: boolean }) {
  if (!show || typeof document === 'undefined') return null;

  return createPortal(
    <div
      className="fixed inset-0 z-[200] flex items-center justify-center bg-[#0F1B2D]/55 p-4 backdrop-blur-[3px]"
      role="status"
      aria-live="polite"
      aria-busy="true"
    >
      <div className="w-full max-w-sm rounded-3xl bg-white p-8 text-center shadow-2xl">
        <div
          className="mx-auto mb-4 flex h-14 w-14 items-center justify-center rounded-2xl shadow-md"
          style={{
            background:
              'linear-gradient(90deg, #8E58A6 0%, #5A4EA6 25%, #145E8C 50%, #007A78 75%, #33A65B 100%)',
          }}
        >
          <Loader2
            className="h-7 w-7 animate-spin text-white"
            strokeWidth={2.5}
            aria-hidden
          />
        </div>
        <h3 className="m-0 text-lg font-semibold text-[#0F1B2D]">
          Building your plan…
        </h3>
        <p className="mt-2 mb-0 text-sm text-[#5B6B7C]">
          Matching screens, peak hours, and budget. This usually takes under a
          minute.
        </p>
      </div>
    </div>,
    document.body,
  );
}
